import { z } from 'zod';

import { NumberPurchaseBody } from '@/api/types';
import { formatNumber } from '@/utils';

const requiredError = 'Это обязательное поле';

export const invalidErrors: Record<
    Exclude<keyof NumberPurchaseBody, 'documents[]' | 'activationTypeId' | 'selectedTariff'>,
    string
> = {
    contactMsisdn: 'Неверный формат номера',
    email: 'Некорректный email',
    firstname: 'Некорректное имя',
    lastname: 'Некорректная фамилия',
    patronymic: 'Некорректное отчество',
    deliveryAddressJson: 'Некорректный адрес',
    deliveryDate: 'Некорректная дата доставки',
    deliveryTimeRangeId: 'Некорректное время доставки',
};

const baseShape = {
    lastname: z.string({ required_error: requiredError }).min(2, requiredError),
    firstname: z.string({ required_error: requiredError }).min(2, requiredError),
    contactMsisdn: z
        .string({ required_error: requiredError })
        .refine(val => String(formatNumber(val)).length === 10, requiredError),
};

export const PurchaseNumberCourierSchema = z.object({
    ...baseShape,
    deliveryDate: z.object(
        { value: z.string(), label: z.string() },
        { required_error: requiredError }
    ),
    deliveryTimeRangeId: z.object(
        { value: z.number(), label: z.string() },
        { required_error: requiredError }
    ),
    deliveryAddressJson: z.string({ required_error: requiredError }).min(1, requiredError),
});

export const PurchaseNumberMailSchema = z.object({
    ...baseShape,
    patronymic: z.string({ required_error: requiredError }).min(2, requiredError),
    deliveryAddressJson: z.string({ required_error: requiredError }).min(1, requiredError),
});

export const PurchaseNumberEsimSchema = z.object({
    contactMsisdn: z
        .string({ required_error: requiredError })
        .refine(val => String(formatNumber(val)).length === 10, requiredError),
    email: z.string({ required_error: requiredError }).email(requiredError),
});
